import { createContext, ReactNode, useContext, useState } from "react"
import { GrupoTarifa, Tarifa } from "src/gql/schema"

export interface TarifaItem extends Omit<Tarifa, "__typename"> {
    costo_total: number
    costo_total_hospedajes_extra: number
    costo_total_horas_extra: number
    costo_total_personas_extra: number
}

export interface GrupoTarifaItem extends Omit<GrupoTarifa, "tarifas"> {
    tarifas?: TarifaItem[]
}

interface Costs {
    extraUsers: number
    extraHours: number
    hospedajes: number
    tax: number
    subtotal: number
    total: number
    totalConIva: number
    totalConPropinas: number
    baseTotal: number
}

type CostsContextType = {
    costs: Costs
    setCosts: React.Dispatch<React.SetStateAction<Costs>>
    gruposTarifasSelected: GrupoTarifaItem[]
    gruposTarifasAdicionalesSelected: GrupoTarifaItem[]
    setGruposTarifasSelected: React.Dispatch<React.SetStateAction<GrupoTarifaItem[]>>
    setGruposTarifasAdicionalesSelected: React.Dispatch<React.SetStateAction<GrupoTarifaItem[]>>
    tarifaBaseHabitacion: Tarifa | null
    setTarifaBaseHabitacion: React.Dispatch<React.SetStateAction<Tarifa | null>>
    tarifaTemporadaAdicionalUltimoDia: Tarifa | null
    setTarifaTemporadaAdicionalUltimoDia: React.Dispatch<React.SetStateAction<TarifaItem | null>>
}

const initialCosts: Costs = {
    extraUsers: 0,
    extraHours: 0,
    hospedajes: 0,
    totalConIva: 0,
    tax: 0,
    total: 0,
    subtotal: 0,
    totalConPropinas: 0,
    baseTotal: 0,
}

const CostsContext = createContext<CostsContextType | undefined>(undefined)

type Props = {
    children: ReactNode
}

export const CostsProvider = ({ children }: Props) => {
    const [costs, setCosts] = useState<Costs>(initialCosts)
    const [gruposTarifasSelected, setGruposTarifasSelected] = useState<GrupoTarifaItem[]>([])
    const [gruposTarifasAdicionalesSelected, setGruposTarifasAdicionalesSelected] = useState<GrupoTarifaItem[]>([])
    const [tarifaBaseHabitacion, setTarifaBaseHabitacion] = useState<Tarifa | null>(null)
    const [tarifaTemporadaAdicionalUltimoDia, setTarifaTemporadaAdicionalUltimoDia] = useState<TarifaItem | null>(null)

    return (
        <CostsContext.Provider value={{
            costs,
            setCosts,
            gruposTarifasSelected,
            setGruposTarifasSelected,
            gruposTarifasAdicionalesSelected, setGruposTarifasAdicionalesSelected,
            setTarifaBaseHabitacion,
            tarifaBaseHabitacion,
            setTarifaTemporadaAdicionalUltimoDia,
            tarifaTemporadaAdicionalUltimoDia
        }}>
            {children}
        </CostsContext.Provider>
    )
}

export const useCosts = () => {
    const context = useContext<CostsContextType | undefined>(CostsContext)

    if (!context) {
        throw new Error("useCosts must be used inside CostsProvider")
    }

    return context
}